import React from 'react';

import { withStyles } from '@mui/styles';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { getAllRstsAsObject } from '../../../utils';
import { connect } from 'react-redux';

const styles = {
  tblTitle: {
    padding: '6px 16px',
    fontWeight: 'bold',
    fontSize: '12px',
  },
  tblCell: {
    padding: '1px 0px 1px 16px',
    fontSize: '12px',
  },
  clm1: {
    width: '10px',
  },
  clm2: {
    width: '300px',
  },
  clm3: {
    width: '400px',
  },
};

export default connect((state) => ({
  light_meta_and_ops: state.meta.light_meta_and_ops
}))(withStyles(styles)((
  {
    data,
    trpls,
    nodes,
    classes,
    dataWithoutTrpls,
    light_meta_and_ops,
  }) => {

  const allRstsAsObject = getAllRstsAsObject(light_meta_and_ops);
  let rowIndex = 0;

  const getTableRow = (rowIndex, rowKey, nodeId, nodeTitle, pid, trplVal) => {
    return (
      <TableRow key={rowKey}>
        <TableCell className={classes.tblCell}>
          {rowIndex}
        </TableCell>

        <TableCell className={classes.tblCell}>
          <a href={"/node/" + nodeId} rel="noreferrer" target="_blank">{nodeId}</a> | {nodeTitle}
        </TableCell>

        <TableCell className={classes.tblCell}>
          {allRstsAsObject[pid] ? (
            allRstsAsObject[pid].title + ' | ' + pid + ' | ' + allRstsAsObject[pid].type
          ) : pid}
        </TableCell>

        <TableCell className={classes.tblCell}>
          {trplVal}
        </TableCell>
      </TableRow>
    );
  };

  return (
    <Table
      style={{
        background: '#fff'
      }}
      className={classes.mb20}
    >
      <TableHead>
        <TableRow>
          <TableCell className={`${classes.tblTitle} ${classes.clm1}`}>#</TableCell>
          <TableCell className={`${classes.tblTitle} ${classes.clm2}`}>Node</TableCell>
          <TableCell className={`${classes.tblTitle} ${classes.clm3}`}>Predicate</TableCell>
          <TableCell className={classes.tblTitle}>Value</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {dataWithoutTrpls ? (Object.keys(data).map((nodeId, nodeIdIdx) => {

          const node = nodes[nodeId];
          const nodeTitle = node && node.title;
          const pid = data[nodeId];
          rowIndex++;

          return getTableRow(rowIndex, nodeIdIdx, nodeId, nodeTitle, pid);

        })) : (Object.keys(data).map((nodeId, nodeIdIdx) => {

          const node = nodes[nodeId];
          const nodeTitle = node && node.title;
          const trplIds = data[nodeId];

          return (
            <React.Fragment key={nodeIdIdx}>
              {Object.values(trplIds).map((trplId, trplIdIdx) => {
                const trpl = trpls[trplId];
                rowIndex++;

                return getTableRow(rowIndex, trplIdIdx, nodeId, nodeTitle, trpl.pid, trpl.value);
              })}
            </React.Fragment>
          );

        }))}
      </TableBody>
    </Table>
  );
}));
